<template>
  <div class="modal-padding" id="#add-freelancer-form">
    <!--     <div class="row">
      <div class="col-12 col-lg-6 ml-auto mr-auto mb-4 mt-4">
        <div class="multisteps-form__progress">
          <button
            :class="step === 1 ? 'js-active' : ''"
            class="multisteps-form__progress-btn"
            type="button"
            title="User Info"
          >
            Step 1
          </button>
          <button
            :class="step === 2 ? 'js-active' : ''"
            class="multisteps-form__progress-btn"
            type="button"
            title="Address"
          >
            Step 2
          </button>
          <button
            :class="step === 3 ? 'js-active' : ''"
            v-if="getManagerUserProfile.employer_freelancers === 2"
            class="multisteps-form__progress-btn"
            type="button"
            title="Contract"
          >
            Step 3
          </button>
          <button
            :class="step === 4 ? 'js-active' : ''"
            v-if="getManagerUserProfile.employer_freelancers === 2"
            class="multisteps-form__progress-btn"
            type="button"
            title="Contract"
          >
            Step 4
          </button>
        </div>
      </div>
    </div> -->
    <section class="pt-4" v-if="step == 1">
      <!--       <div class="row justify-content-center">
        <div class="col-md-11 d-flex">
          <button @click="showModal = true" class="btn btn-primary btn-custom ml-auto text-nowrap">
            Copy Existing
          </button>

          <CustomMainModal @close="closeModal" v-show="showModal" modalSize="modal-sm">
            <template v-slot:header>
              <h5>Copy Existing Job</h5>
            </template>

            <div class="form-group m-label-left">
              <select
                class="form-control form-control"
                @change="handleEmployerJobs($event)"
                v-model="selectedJobModel"
                id="empl"
              >
                <option
                  v-if="getManagerJobsDropdown.length === 0"
                  :value="{
                    id: '',
                    title: 'No registered jobs',
                    city: { name: '' },
                    country: { name: '' },
                  }"
                >
                  No registered jobs
                </option>
                <option
                  v-for="job in getManagerJobsDropdown"
                  :key="job.id"
                  :value="{
                    id: job.id,
                    title: job.job_name,
                    city: { name: '' },
                    country: { name: '' },
                  }"
                >
                  {{ job.job_name }}, {{ job.city.name }}
                </option>
              </select>
              <label for="empl">Job</label>
            </div>

            <div class="modal-footer d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-primary btn-custom"
                @click="copyExistingJob"
                :disabled="selectedJobModel ? false : true"
              >
                Copy
              </button>
              <button type="button" class="btn btn-secondary btn-custom" @click="closeModal">
                Cancel
              </button>
            </div>
          </CustomMainModal>
        </div>
      </div>
 -->
      <div class="row justify-content-center">
        <div class="col-md-11">
          <!-- error msg -->
          <Message v-show="errorMessage" class="mt-2" type="error-alert">
            <!-- <h4 slot="heading" class="alert-heading">Something went wrong!</h4> -->
            <p slot="alert-message" class="mb-0">{{ errorMessage }}</p>
          </Message>

          <form submit.prevent>
            <div class="form-group m-label-left isWidth required-fixed-right">
              <input
                type="text"
                v-model.trim="$v.selectedFields.selectedJobTitle.$model"
                @change="stepValidator"
                class="form-control my-3"
                id="job-title"
                :class="{
                  'is-invalid': $v.selectedFields.selectedJobTitle.$error,
                  'is-valid': !$v.selectedFields.selectedJobTitle.$invalid,
                }"
                required
              />
              <label for="job-title">Job title</label>
            </div>

            <div class="form-group m-label-left isWidth required-fixed-right">
              <input
                id="exp"
                type="text"
                v-model.trim.lazy="$v.selectedFields.selectedExperience.$model"
                @change="stepValidator"
                class="form-control"
                :class="{
                  'is-invalid': $v.selectedFields.selectedExperience.$error,
                  'is-valid': !$v.selectedFields.selectedExperience.$invalid,
                }"
                aria-describedby="MinimumYearsOfExperienceHelp"
              />
              <label for="exp">Minimum years of experience</label>
            </div>

            <div class="form-group m-label-left filter-item">
              <v-select
                v-model="selectedFields.competences"
                @search="oncompetenceSearch"
                label="name"
                :options="getCompetencesFilterList"
                :reduce="comp => comp"
                :clearable="true"
                multiple
                id="add-job-competences"
              >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching && search.length >= 3">
                    No results found for <em>{{ search }}</em
                    >.
                  </template>
                  <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                </template>
              </v-select>
              <label for="competences">Required competencies</label>
            </div>

            <div class="form-group m-label-left filter-item">
              <v-select
                v-model="selectedFields.advantageCompetences"
                label="name"
                :options="[...getCompetencesFilterList]"
                :reduce="comp => comp"
                :clearable="true"
                multiple
                id="advantage"
              >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching && search.length >= 3">
                    No results found for <em>{{ search }}</em
                    >.
                  </template>
                  <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                </template>
              </v-select>
              <label for="advantage">Advantage competencies</label>
            </div>

            <div class="form-group m-label-left filter-item">
              <v-select
                v-model="selectedFields.languages"
                id="Languages"
                label="name"
                :options="getLanguagesList"
                :reduce="lang => lang"
                :clearable="true"
                multiple
              >
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching && search.length >= 3">
                    No results found for <em>{{ search }}</em
                    >.
                  </template>
                  <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                </template>
              </v-select>
              <label for="Languages">Language skills</label>
            </div>

            <!--  <div class="form-group m-label-left isWidth">
              <input
                type="text"
                id="street-address"
                v-model="selectedFields.address"
                class="form-control"
                required
              />
              <label for="street-address">Street address</label>
            </div> -->
            <!-- 
            <div class="row">
              <div class="form-group m-label col-md-4">
                <input
                  type="text"
                  id="postal-code"
                  v-model="selectedFields.postal"
                  class="form-control"
                  required
                />
                <label for="postal-code">Postal code</label>
              </div>
              <div class="form-group m-label filter-item col-md-8 required-fixed-city">
                <v-select
                  v-model="selectedFields.selectedCity"
                  @change="stepValidator"
                  label="name"
                  :options="getCitiesListByCountry"
                  :reduce="city => city"
                  :clearable="true"
                  id="city"
                >
                  <template v-slot:no-options>
                    <div style="opacity: 0.5">Please select a country first</div>
                  </template>
                </v-select>
                <label for="city">City</label>
              </div>
            </div> -->
            <!-- Countries -->
            <!--             <div class="form-group filter-item m-label-left isWidth required-fixed-country">
              <v-select
                v-model="$v.selectedFields.selectedCountry.$model"
                @input="fetchCitiesByCountryId"
                @change="stepValidator"
                :options="getAllCountries"
                label="name"
                :reduce="country => country"
                :clearable="true"
                id="country"
                :class="{
                  'is-invalid': $v.selectedFields.selectedCountry.$error,
                  'is-valid': !$v.selectedFields.selectedCountry.$invalid,
                }"
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Sorry, no matching country</div>
                </template>
              </v-select>
              <label for="country">Country</label>
            </div> -->

            <!--             <div class="form-group m-label-left isWidth required-fixed-country">
              <select
                id="employment"
                v-model="selectedFields.selectedEmploymentType"
                @change="stepValidator"
                class="form-select my-3 w-100"
                :class="{
                  'is-invalid': $v.selectedFields.selectedEmploymentType.$error,
                  'is-valid': !$v.selectedFields.selectedEmploymentType.$invalid,
                }"
              >
                <option value="1">Employment</option>
                <option value="2">Self-employment</option>
                <option value="3">Employment / Self-Employment</option>
              </select>
              <label for="employment">Employment type</label>
            </div> -->
          </form>
        </div>
      </div>
    </section>

    <section class="pt-4" v-if="step === 2">
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="form-group m-label-left isWidth required-fixed-right">
            <input
              v-model="selectedFields.individiuals"
              id="number"
              type="text"
              class="form-control"
            />
            <label for="number">Number of freelancers needed </label>
          </div>
          <div class="form-group m-label-left isWidth required-fixed-country">
            <select id="full-time" v-model="selectedFields.duration" class="form-select my-3 w-100">
              <option value="3">Less than 1 month</option>
              <option value="4">1-3 months</option>
              <option value="5">3-6 months</option>
              <option value="6">6-12 months</option>
              <option value="7">More than 12 months</option>
            </select>
            <label for="full-time">Duration</label>
          </div>
          <div class="form-group m-label-left isWidth required-fixed-country">
            <select id="full-time" v-model="selectedFields.fullTime" class="form-select my-3 w-100">
              <option :value="true">Yes</option>
              <option :value="false">No</option>
            </select>
            <label for="full-time">Full-time</label>
          </div>

          <div class="form-group">
            <textarea
              v-model="selectedFields.comments"
              class="form-control add-job-comments"
              id="add-job-comments"
              rows="4"
              placeholder="Enter a short description of the position and work. You can also share other things related to your needs here."
            ></textarea>
          </div>

          <div class="row justify-content-center" v-show="showEditor" :key="componentKey">
            <div class="col-md-11">
              <Editor v-model="jobAdText" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="pt-4" v-if="step === 3 && getManagerUserProfile.employer_freelancers === 2">
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div
            v-if="getManagerUserProfile.employer_registration_number === null"
            class="form-group m-label-left isWidth required-fixed-right"
          >
            <input v-model="selectedFields.regNumber" id="reg" type="text" class="form-control" />
            <label for="reg">Registration number</label>
          </div>

          <div
            v-if="getManagerUserProfile.employer_eu_vat_number === null"
            class="form-group m-label-left isWidth"
          >
            <input v-model="selectedFields.vat" id="vat" type="text" class="form-control" />
            <label for="vat"
              ><span style="text-transform: uppercase!important;">EU VAT </span>number</label
            >
          </div>

          <div
            v-if="getManagerUserProfile.employer_invoice_email === null"
            class="form-group m-label-left isWidth"
          >
            <input
              v-model="selectedFields.invoiceEmail"
              id="invoice"
              type="text"
              class="form-control"
            />
            <label for="invoice">Email for invoices</label>
          </div>
          <div class="mb-2" v-if="getManagerUserProfile.employer_registration_number === null">
            Please enter your company registration number.
          </div>
          <div class="mb-2" v-if="getManagerUserProfile.employer_eu_vat_number === null">
            If you're based in the EU, include your EU VAT number for invoicing purposes.
          </div>
          <div class="mb-2" v-if="getManagerUserProfile.employer_invoice_email === null">
            Invoices are sent via email. If you'd like them sent to a specific inbox, please provide
            that email address above.
          </div>
        </div>
      </div>
    </section>

    <section class="pt-4" v-if="step === 4 && getManagerUserProfile.employer_freelancers === 2">
      <div class="row justify-content-center">
        <div class="row">
          <div class="contract">
            <div class="col-md-12" v-html="previewContract()"></div>
            <div class="sign">
              <canvas ref="signaturePad" class="signature-pad"></canvas>
            </div>
            <div
              style="padding-left: 8%; padding-right: 8%; align-items: center; margin-top: 5px;"
              class="d-flex"
            >
              <span style="font-size: 13px;"
                >Sign by drawing your signature in the yellow field</span
              >

              <button class="ms-auto btn btn-secondary" style="font-size: 13px;" @click="clear">
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- VALIDATION MESSAGES -->
    <div v-if="$v.selectedFields.selectedJobTitle.$error">
      <div
        v-if="!$v.selectedFields.selectedJobTitle.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        <!-- {{ errorHandler($v.selectedFields.firstName.$error) }} -->
        Title field is required.
      </div>
    </div>

    <div v-if="$v.selectedFields.selectedCountry.$error">
      <div
        v-if="!$v.selectedFields.selectedCountry.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        Country field is required.
      </div>
    </div>

    <div v-if="$v.selectedFields.selectedEmploymentType.$error">
      <div
        v-if="!$v.selectedFields.selectedEmploymentType.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        Country field is required.
      </div>
    </div>

    <div v-if="$v.selectedFields.selectedExperience.$error">
      <div
        v-if="!$v.selectedFields.selectedExperience.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        Minimum Years of Experience field is required.
      </div>
    </div>

    <div v-if="$v.selectedFields.selectedRelocation.$error">
      <div
        v-if="!$v.selectedFields.selectedRelocation.required"
        class="alert alert-danger text-center"
        role="alert"
      >
        Relocation field is required.
      </div>
    </div>

    <!-- Nav btn's -->
    <div
      v-if="getManagerUserProfile.employer_freelancers === 3"
      class="row justify-content-center mb-5 mt-4"
    >
      <div class="col-md-11 mx-auto">
        <div
          class="row justify-content-between"
          :class="getManagerUserProfile.employer_freelancers === 2 ? 'custom-padding' : ''"
        >
          <div class="col-5 text-center">
            <button
              class="btn btn-primary btn-custom w-100 mr-5 prev"
              @click="
                prev();
                stepValidator();
              "
              :disabled="step === 1 || step < 0"
            >
              <i class="fa fa-chevron-left mr-3"></i> Back
            </button>
          </div>
          <div
            class="text-center"
            :class="
              getManagerUserProfile.employer_freelancers !== 2 && step === 2 ? 'col-6' : 'col-5'
            "
          >
            <button
              v-if="step === 2"
              type="submit"
              form="add-for-job"
              class="btn btn-secondary btn-custom next w-100"
              @click="saveAndPublishAd(1)"
              :disabled="selectedFields.individiuals.length === 0"
            >
              <span>Submit Request</span>
            </button>

            <button
              v-else
              type="submit"
              form="add-for-job"
              class="btn btn-secondary btn-custom w-100 next"
              @click="
                next();
                stepValidator();
              "
              :disabled="
                selectedFields.selectedJobTitle.length === 0 ||
                  selectedFields.selectedExperience.length === 0
              "
            >
              Next
              <i class="fa fa-chevron-right ml-3"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="row justify-content-center mb-5 mt-4">
      <div class="col-md-11 mx-auto">
        <div
          class="row justify-content-between"
          :class="getManagerUserProfile.employer_freelancers === 2 ? 'custom-padding' : ''"
        >
          <div class="col-5 text-center">
            <button
              class="btn btn-primary btn-custom w-100 mr-5 prev"
              @click="
                prev();
                stepValidator();
              "
              :disabled="step === 1 || step < 0"
            >
              <i class="fa fa-chevron-left mr-3"></i> Back
            </button>
          </div>

          <div
            class="text-center"
            :class="
              getManagerUserProfile.employer_freelancers !== 2 && step === 2 ? 'col-6' : 'col-5'
            "
          >
            <button
              v-if="step === 4 && signaturePad"
              :disabled="signaturePad._data.length === 0"
              type="submit"
              form="add-for-job"
              class="btn btn-secondary btn-custom w-100 next cs-button"
              @click="submitTemplate()"
            >
              Sign Agreement
            </button>

            <button
              v-if="step === 3"
              :disabled="selectedFields.regNumber === null || selectedFields.regNumber.length === 0"
              type="submit"
              form="add-for-job"
              class="btn btn-secondary btn-custom w-100 next"
              @click="openContract()"
            >
              Next
              <i class="fa fa-chevron-right ml-3"></i>
            </button>

            <button
              v-if="step !== 4 && step !== 3"
              type="submit"
              form="add-for-job"
              class="btn btn-secondary btn-custom w-100 next"
              @click="
                next();
                stepValidator();
              "
              :disabled="
                selectedFields.selectedJobTitle.length === 0 ||
                  selectedFields.selectedExperience.length === 0
              "
            >
              Next
              <i class="fa fa-chevron-right ml-3"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Editor from '@/components/common/TextEditor';
import Message from '@/components/AlertMessages/Message';
import CustomMainModal from '../../Modals/CustomMainModal';
import { errorService } from '../../../services/errorService';
import { required, minLength } from 'vuelidate/lib/validators';
import Spinner from '../../common/LoadingSpinner/Spinner';
import { degreeMixin } from '../../../mixins/degreeMixin';
import SignaturePad from 'signature_pad';
import axios from 'axios';
// import format from 'date-fns/format';
// import moment from 'moment';

export default {
  components: {
    Spinner,
    Editor,
    Message,
    CustomMainModal,
  },
  mixins: [degreeMixin],
  props: {
    userProfile: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    goToId: '',
    currentDate: '',
    currentDateHours: '',
    signaturePad: null,
    signature: '',
    selectedJobModel: null,
    showEditor: false,
    isLoading: false,
    isReadonly: false,
    componentKey: 0,
    showModal: false,
    hidePassword: true,
    errorMessage: '',
    signIn: false,
    step: 1,
    regenerate: false,
    isGenerating: true,
    citiesList: ['sofia'],
    /* Date data */
    dateFormat: 'D MMM YYYY',
    startDate: '',
    endDate: '',
    isActive: false,
    isLangActive: false,
    isCompetenceActive: false,
    isCompetenceAdvActive: false,
    jobAdText: '',
    employerSelectedOption: [],
    selectedFields: {
      description: '',
      benefits: '',

      competences: [],
      advantageCompetences: [],
      selectedExperience: '',
      languages: [],
      selectExistingJobAd: 'Job Ad',
      selectedEmployer: '',
      selectedJobTitle: '',
      selectedEmploymentType: '2',
      selectedDegree: '',
      selectedRelocation: false,
      comments: '',
      selectedCountry: { id: '', name: '', part_of_eu: null, phone_code: '', source: '' },
      selectedCity: { id: '', name: '', part_of_eu: null, phone_code: '', source: '' },
      countryId: '',
      degreeField: '',
      address: '',
      postal: '',
      individiuals: 1,
      fullTime: true,
      duration: 7,
      vat: '',
      regNumber: '',
      invoiceEmail: '',
    },
    competencesOptions: [],
    languagesOptions: [],
    isNextDisabled: true,
    isCopied: false,
    isGeneratedOnce: false,
  }),
  validations: {
    selectedFields: {
      selectedJobTitle: {
        required,
        minLength: minLength(3),
      },
      selectedCountry: {
        required,
      },
      selectedEmploymentType: {
        required,
      },
      selectedExperience: {
        required,
      },
      selectedRelocation: {
        required,
      },
    },
  },
  methods: {
    ...mapActions([
      'retrieveJobsForEmployerDropdown',
      'retrieveCitiesListByCountryId',
      'retrieveCompetencesList',
      'copyExistingJobAd',
      'retrieveJobAdById',
      'AddJobAd',
      /* 'retrieveLanguagesList', */
      /* 'retrieveAllCountries', */
    ]),
    ...mapActions('managerStoreModule', [
      'ManagerAddJob',
      'retrieveManagerUserProfile',
      'retrieveManagerJobsDropdown',
      'retrieveManagerJobAdByIdForCopyExisting',
      'retrieveManagerJobById',
    ]),
    stepValidator() {
      // STEP 1
      if (this.step === 1) {
        if (
          this.$v.selectedFields.selectedJobTitle.$invalid === true ||
          this.$v.selectedFields.selectedEmploymentType.$invalid === true ||
          this.$v.selectedFields.cityId ||
          this.$v.selectedFields.countryId
        ) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }
      }
      //STEP 2
      if (this.step === 2) {
        if (this.$v.selectedFields.selectedExperience.$invalid === true) {
          this.isNextDisabled = true;
        } else {
          this.isNextDisabled = false;
        }
      }
    },
    handleEmployerJobs() {
      this.isLoading = false;
    },
    copyExistingJob() {
      this.retrieveManagerJobAdByIdForCopyExisting({ jobID: this.selectedJobModel.id })
        .then(({ data }) => {
          this.selectedFields.selectedJobTitle = data.title;
          this.selectedFields.address = data.address.address;
          this.selectedFields.postal = data.address.postal_code;

          this.selectedFields.selectedCountry = {
            id: data.country.id,
            name: data.country.name,
            part_of_eu: null,
            phone_code: '',
            source: '',
          };

          this.selectedFields.selectedCity = {
            id: data.city.id,
            name: data.city.name,
            part_of_eu: null,
            phone_code: '',
            source: '',
          };

          this.selectedFields.selectedEmploymentType = data.employment_type;
          this.selectedFields.selectedExperience = data.years_experience;
          this.selectedFields.selectedDegree = data.degree_type
            ? data.degree_type.toString()
            : data.degree_type;

          this.selectedFields.degreeField = data.degree_field;

          this.selectedFields.competences = [...data.required_competences];
          this.selectedFields.advantageCompetences = [...data.advantage_competences];
          this.selectedFields.languages = [...data.languages];
          this.selectedFields.selectedRelocation = data.relocation;

          //this.selectedFields.description = data.description;

          this.selectedFields.aboutUs = data.about_us
            ? this.removeHtmlTags(data.about_us, 'b', 'u', 'p', 'br')
            : '';

          this.selectedFields.benefits = data.benefits
            ? data.benefits
            : this.selectedFields.benefits;

          this.generateCopyExistingJobAd(data.description);
        })
        .then(() => {
          this.closeModal();
        })
        .catch(err => {
          //   this.isCopied = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });

      if (this.selectedFields.selectedEmploymentType) {
        this.isNextDisabled = false;
      }
    },
    generateCopyExistingJobAd(description) {
      this.isCopied = true;
      this.jobAdText = this.removeHtmlTags(description, 'div');
    },
    closeModal() {
      this.showModal = false;
      this.selectedJobModel = null;
    },
    oncompetenceSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.competencesOptions = this.getCompetencesFilterList;
      }

      loading(false);
    },
    /*  onLanguageSearch(search, loading) {
      if (search.length >= 3) {
        loading(true);
        this.languagesOptions = this.getLanguagesList;
      }

      loading(false);
    }, */
    fetchCitiesByCountryId() {
      this.retrieveCitiesListByCountryId({ id: this.selectedFields.selectedCountry.id });
      this.selectedFields.selectedCity = '';
    },
    forceRerender() {
      this.componentKey++;
      this.isReadonly = false;
    },
    saveAd() {
      this.isLoading = true;
      let js_employer_id;
      if (this.$route.name == 'employer_id') {
        js_employer_id = this.$route.params.employer_id;
      } else {
        js_employer_id = this.selectedFields.selectedEmployer.id;
      }

      this.AddJobAd({
        js_employer_id: js_employer_id,
        title: this.selectedFields.selectedJobTitle,
        description: this.jobAdText,
        country_id: this.selectedFields.selectedCountry.id,
        city_id: this.selectedFields.selectedCity.id,
        street: this.selectedFields.address,
        postal_code: this.selectedFields.postal,
        employment_type: this.selectedFields.selectedEmploymentType,
        years_experience: this.selectedFields.selectedExperience,
        degree: this.selectedFields.selectedDegree,
        degree_field: this.selectedFields.degreeField,
        workplace: 3,
        competences: this.selectedFields.competences.map(c =>
          c.hasOwnProperty('competence_id') ? c.competence_id : c.id,
        ),
        advantage_competences: this.selectedFields.advantageCompetences.map(advantageCompetence =>
          advantageCompetence.hasOwnProperty('competence_id')
            ? advantageCompetence.competence_id
            : advantageCompetence.id,
        ),
        languages: this.selectedFields.languages.map(l =>
          l.hasOwnProperty('language_id') ? l.language_id : l.id,
        ),
        relocation: this.selectedFields.selectedRelocation,
        /* advertizing_start_date: this.startDate,
        advertizing_end_date: this.endDate, */
        comments: this.selectedFields.comments,
        status: 0,
      })
        .then(response => {
          this.isLoading = false;

          this.$toasted.success(`You successfully added a job`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });

          this.$router.push({
            name: 'manager_job_uuid',
            params: { manager_job_uuid: response.id },
          });

          location.reload();

          this.jobAdText = '';
          this.isGeneratedOnce = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },

    isThereAContract() {
      if (this.selectedFields.individiuals === 0) {
        this.$toasted.error('Number of individuals must be at least 1', {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 8000,
        });
        this.isLoading = false;
        return false;
      }

      if (this.getManagerUserProfile.employer_freelancers === 2) {
        this.openContract();
      } else {
        this.saveAndPublishAd(1);
      }
    },

    saveAndPublishAd(status) {
      this.isLoading = true;

      this.ManagerAddJob({
        title: this.selectedFields.selectedJobTitle,
        description: this.jobAdText,
        note: this.selectedFields.comments,
        country_id: this.selectedFields.selectedCountry.id,
        city_id: this.selectedFields.selectedCity.id,
        street: this.selectedFields.address,
        postal_code: this.selectedFields.postal,
        employment_type: this.selectedFields.selectedEmploymentType,
        years_experience: this.selectedFields.selectedExperience,
        degree_type: this.selectedFields.selectedDegree,
        degree_field: this.selectedFields.degreeField,
        individuals_number: this.selectedFields.individiuals,
        full_time: this.selectedFields.fullTime,
        duration: this.selectedFields.duration,
        summary: this.selectedFields.comments,
        service_level: 4,
        workplace: 3,
        competences: this.selectedFields.competences.map(c =>
          c.hasOwnProperty('competence_id') ? c.competence_id : c.id,
        ),
        advantage_competences: this.selectedFields.advantageCompetences.map(advantageCompetence =>
          advantageCompetence.hasOwnProperty('competence_id')
            ? advantageCompetence.competence_id
            : advantageCompetence.id,
        ),
        languages: this.selectedFields.languages.map(l =>
          l.hasOwnProperty('language_id') ? l.language_id : l.id,
        ),
        relocation: this.selectedFields.selectedRelocation,
        comments: this.selectedFields.comments,
        status: status,
        eu_vat_number: this.selectedFields.vat,
        invoice_email: this.selectedFields.invoiceEmail,
        registration_number: this.selectedFields.regNumber,
      })
        .then(response => {
          this.isLoading = false;

          if (this.getManagerUserProfile.employer_freelancers !== 2) {
            this.$toasted.success(`You successfully submitted the request`, {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 10000,
            });
          }

          this.$router.push({
            name: 'manager_job_uuid',
            params: { manager_job_uuid: response.data.id },
          });

          /*           this.$router.push({
            name: 'manager_job_uuid',
            params: { manager_job_uuid: response.data.id },
          }); */

          //  location.reload();

          /*  this.jobAdText = '';
          this.isGeneratedOnce = false; */
          this.closeModal();
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    openContract(id) {
      this.step = 4;
      this.goToId = id;
      this.$nextTick(() => {
        this.getCETDateHours();
        const canvas = this.$refs.signaturePad;
        if (canvas) {
          this.signaturePad = new SignaturePad(canvas, {
            penColor: 'rgb(66, 133, 244)',
          });
          this.resizeCanvas();
          window.addEventListener('resize', this.resizeCanvas);
        }
      });
    },
    resizeCanvas() {
      const canvas = this.$refs.signaturePad;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      this.signaturePad.clear();
    },
    clear() {
      this.signaturePad.clear();
    },
    save() {
      if (this.signaturePad.isEmpty()) {
        alert('Please provide a signature first.');
      } else {
        this.signature = this.signaturePad.toDataURL();
      }
    },
    submitTemplate() {
      this.isLoading = true;
      this.save();
      this.getCETDate();
      let htmlContent = this.generateHtmlString();
      let requestData = JSON.stringify({
        htmlContent: htmlContent,
      });
      const formData = new FormData();
      formData.append('html', requestData);
      formData.append('signature', this.signature);
      formData.append('signing_date', this.currentDate);
      formData.append('type', 4);
      axios({
        method: 'post',
        data: formData,
        url: `${process.env.VUE_APP_API_URL}/manager/agreements/create`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'multipart/form-data',
          'Cache-Control': 'no-cache',
        },
      })
        .then(response => {
          this.isLoading = false;
          this.saveAndPublishAd(1);
          this.$toasted.success(`You successfully signed the agreement`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        })
        .catch(error => {
          this.isLoading = false;
        });
    },
    next() {
      this.step++;

      if (this.step === 2) {
        this.isNextDisabled = false;

        if (!this.isGeneratedOnce && !this.isCopied) {
          this.generateAd();
          this.isGeneratedOnce = true;
        }

        this.forceRerender();
      }

      if (
        this.step === 3 &&
        this.getManagerUserProfile.employer_registration_number !== null &&
        this.getManagerUserProfile.employer_eu_vat_number !== null &&
        this.getManagerUserProfile.employer_invoice_email !== null
      ) {
        this.step++;
        this.openContract();
      }
    },
    prev() {
      this.step--;
      if (
        this.step === 3 &&
        this.getManagerUserProfile.employer_registration_number !== null &&
        this.getManagerUserProfile.employer_eu_vat_number !== null &&
        this.getManagerUserProfile.employer_invoice_email !== null
      ) {
        this.step--;
      }
    },

    competencesList(competencesList) {
      const list = competencesList.map(c => c.name).join(', ');

      let final = '';

      if (list.lastIndexOf(',') !== -1) {
        final = `${list.slice(0, list.lastIndexOf(','))} and${list.slice(
          list.lastIndexOf(',') + 1,
        )}`;
      } else {
        final = list;
      }

      return final;
    },
    removeMoreHtmlTags(adText, ...args) {
      const regex = /<(\/?)(\w+)[^>]*\/?>/g;
      if (adText) {
        return adText
          .replace(regex, (_, endMark, tag) => {
            return args.includes(tag) ? '<' + endMark + tag + '>' : '';
          })
          .replace(/\r?\n/g, '')
          .replace(/<!--.*?-->/g, '');
      } else {
        return '';
      }
    },
    removeHtmlTags(adText, ...args) {
      // const regex = /(<([^>]+)>)/gi;
      const removeAllDivTags = /<[/]{0,1}(div)[^><]*>/g;

      return adText
        .replace(removeAllDivTags, '')
        .replace(/<!--.*?-->/g, '')
        .replace(/\r?\n/g, '');
    },
    addLiNodes() {
      const nodesList = [];

      const getDegreeNode = (degreeCode, field) => {
        switch (Number(degreeCode)) {
          case 1:
            return `University level studies`;
          case 2:
            return `Bachelor's degree in ${field} or similar`;
          case 3:
            return `Master's degree in ${field} or similar`;
          case 4:
            return `PhD in ${field} or similar`;
          default:
            return '';
        }
      };

      // [Years of experience]+ years of relevant working experience
      if (this.selectedFields.selectedExperience) {
        nodesList.push(
          `<li>${this.selectedFields.selectedExperience} years of relevant working experience</li>`,
        );
      }

      // Solid experience in [Skill1], [Skill2], … and [SkillN]
      if (this.selectedFields.competences.length) {
        nodesList.push(
          `<li>Solid experience in ${this.competencesList(this.selectedFields.competences)}</li>`,
        );
      }

      // If degree is selected then one of these: University level studies, Bachelor’s degree in [degree field] or similar, Master’s degree in [degree field] or similar, PhD in [degree field] or similar
      if (this.selectedFields.selectedDegree) {
        nodesList.push(
          `<li>${getDegreeNode(
            this.selectedFields.selectedDegree,
            this.selectedFields.degreeField,
          )}</li>`,
        );
      }

      // Good [Language1], [Language2], … and [LanguageN] skills verbally and in writing
      if (this.selectedFields.languages.length) {
        nodesList.push(
          `<li>Good ${this.competencesList(
            this.selectedFields.languages,
          )} skills verbally and in writing</li>`,
        );
      }

      return nodesList;
    },

    generateAd() {
      const nodes = this.addLiNodes();

      let employerName = '';
      let employerAboutUs = '';

      if (this.$route.path === '/manager/user/jobs') {
        employerName = this.removeMoreHtmlTags(this.getManagerUserProfile.employer_name, '<p>');
        employerAboutUs = this.removeMoreHtmlTags(
          this.getManagerUserProfile.employer_description,
          '<p>',
          '<div>',
        );
      } else {
        employerName = this.removeMoreHtmlTags(this.getManagerProfile.employer_name, '<p>');
        employerAboutUs = this.removeMoreHtmlTags(
          this.getManagerProfile.description,
          '<p>',
          '<div>',
        );
      }

      /*
      const employerName = this.removeMoreHtmlTags(this.getManagerProfile.employer_name, '<p>');
      const employerAboutUs = this.removeMoreHtmlTags(
        this.getManagerProfile.description,
        '<p>',
        '<div>',
      ); */

      const previousExperiance = `<li>Have previous experience in ${this.competencesList(
        this.selectedFields.advantageCompetences,
      )}</li>`;

      this.jobAdText = `(Introduction text)
      <p><b>We believe that you have the following qualifications:</b></p><ul>${
        nodes.length ? nodes.join('') : null
      }</ul><br /><b>It's an advantage if you:</b><ul>${
        this.selectedFields.advantageCompetences.length ? previousExperiance : null
      }</ul><br /><b>Benefits:</b>${
        this.selectedFields.benefits ? this.selectedFields.benefits : ''
      }<p></br></p><p>If you find our proposal interesting and you meet the above requirements for the position, please don't hesitate to apply.</p><br /><p>All applications will be treated strictly confidential.</p><br /><p><i>About ${employerName}: </i></p><i>${this.removeMoreHtmlTags(
        employerAboutUs,
        '<div>',
        '<p>',
      )}</i>`;

      this.forceRerender();
    },
    reGenerateAd() {
      const nodes = this.addLiNodes();

      let employerName = '';
      let employerAboutUs = '';

      if (this.$route.path === '/manager/user/jobs') {
        employerName = this.removeMoreHtmlTags(this.getManagerUserProfile.employer_name, '<p>');
        employerAboutUs = this.removeMoreHtmlTags(
          this.getManagerUserProfile.employer_description,
          '<p>',
          '<div>',
        );
      } else {
        employerName = this.removeMoreHtmlTags(this.getManagerProfile.employer_name, '<p>');
        employerAboutUs = this.removeMoreHtmlTags(
          this.getManagerProfile.description,
          '<p>',
          '<div>',
        );
      }

      const previousExperiance = `<li>Have previous experience in ${this.competencesList(
        this.selectedFields.advantageCompetences,
      )}</li>`;

      this.jobAdText = `(Introduction text)
      <p><b>We believe that you have the following qualifications:</b></p><ul>${
        nodes.length ? nodes.join('') : null
      }</ul><br /><b>It's an advantage if you:</b><ul>${
        this.selectedFields.advantageCompetences.length ? previousExperiance : null
      }</ul><br /><b>Benefits:</b>${
        this.selectedFields.benefits ? this.selectedFields.benefits : ''
      }<p></br></p><p>If you find our proposal interesting and you meet the above requirements for the position, please don't hesitate to apply.</p><br /><p>All applications will be treated strictly confidential.</p><br /><p><i>About ${employerName}: </i></p><i>${this.removeMoreHtmlTags(
        employerAboutUs,
        '<div>',
        '<p>',
      )}</i>`;

      this.forceRerender();
    },

    previewContract() {
      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Agreement for Freelance Mediation Services</title>
    <style>
    @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
        .freelancing-container {
           font-family: "Lato", sans-serif;
           padding-left:20px;
           padding-right:20px;
        }
        .freelancing-container p {
          font-size: 14px
        }
        .freelancing-container  h2 {
          font-size:18px;
          font-weight:800;
        }
        .freelancing-container  h3 {
          font-weight:800;
          font-size:13px;
          margin-bottom:20px;
          margin-top:20px;
        }

        .freelancing-container .flex {
          display:flex;
          justify-content: space-between;
          align-items: center;
        }

        .freelancing-container .flex img {
        width:50%;
        height:auto;
        }
    </style>
</head>
<body>
    <div class="freelancing-container">
    <img style="max-width:200px; margin-bottom:60px; margin-left:-50px; margin-top:30px" src="https://jobshark.eu/img/comstream-logo.af65b641.png" alt="Comstream logo" />
        <h2 style="margin-bottom:30px;">Agreement for Freelance Mediation Services</h2>
        <p style="margin-bottom:25px;">
            This is an agreement between Comstream AB, a Swedish entity with registration number 556945-8911, hereinafter referred to as ”Comstream” and ${this.getManagerUserProfile.employer_name}, an entity based in ${this.getManagerUserProfile.employer_country.name} with registration number ${this.selectedFields.regNumber}, hereinafter referred to as “the Customer” regarding mediation of professional freelancers, hereinafter “the Service”.
        </p>
        <h3>1. General Conditions</h3>
        <p class="section-title">1.1. The Customer hereby appoints Comstream to find, qualify and present suitable individuals, hereinafter ”Candidates”, for a certain project, hereinafter ”the Project”. An accepted Candidate, hereinafter the “IT Professional”, is rented out by Comstream to the Customer on an hourly basis.</p>
        <p class="section-title">1.2. Comstream shall present hourly fee, CV and other relevant received information regarding a Candidate to the Customer. The Customer may not disclose information about the Candidate to third parties without Comstream’s prior approval.</p>
        <p class="section-title">1.3. On request by the Customer, Comstream shall provide possibility to interview the Candidate personally or by video meeting, phone or other similar way. In the occurrence of any travelling expenses related to such meetings, the Customer shall bear these costs.</p>
        <p class="section-title">1.4. The IT Professional is under the disposal, management and supervision of the Customer in order to conduct work that is related to the Customer’s business.</p>

        <h3>2. Responsibilities of the Parties</h3>
        <p class="section-title">2.1. Comstream shall use its best efforts to find suitable Candidates for the Customer for each Project.</p>
        <p class="section-title">2.2. It is the responsibility of the Customer to provide Comstream with an adequate description of the Project and other relevant information about the Project.</p>

        <h3>3. Fees and Payment Terms</h3>
        <p class="section-title">3.1. The Customer shall pay an hourly fee per IT Professional to Comstream. The fee will be invoiced monthly with twenty (20) days payment terms.</p>
        <p class="section-title">3.2. The level of the hourly rate is agreed upon as the Customer accepts a Candidate. Thereafter it may be revised every twelve (12) months by one (1) month’s written notice by Comstream.</p>
        <p class="section-title">3.3. Other paid actual costs, such as software license fees, allowances, travelling and lodging expenses, that may occur for the IT Professional based on instructions by the Customer are charged at cost price to the Customer.</p>
        <p class="section-title">3.4. If the customer, directly or indirectly, contracts or employs a Candidate without the written consent of Comstream, Comstream has the right to a compensation corresponding to 320 hours but never less than 12.000 EUR per Candidate.</p>
        <p class="section-title">3.5. In case of delay of payment of amounts due, the Customer shall be obliged to pay penalty interest amounting to 12% per year. All mentioned fees are exclusive of VAT.</p>

        <h3>4. Termination</h3>
        <p class="section-title">4.1. Each Party may, at any time, terminate this Contract for all or for individual IT Professionals by thirty (30) days’ written notice.</p>
        <p class="section-title">4.2. Comstream’s right to compensation according to 3.4 is valid during the effective time of the agreement and one (1) year thereafter.</p>

        <h3>5. Secrecy and Intellectual Property Rights</h3>
        <p class="section-title">5.1. Any information received by one party shall be treated as strictly confidential by the other party and the receiving party shall not communicate the information in any form to any third party.</p>
        <p class="section-title">5.2. All intellectual property rights for what is produced by the IT Professional under this agreement shall be solely owned by the Customer, provided that this is not contradicting with applicable laws or regulations.</p>

        <h3>6. Processing of Personal Data</h3>
        <p class="section-title">6.1. Comstream and the Customer are jointly considered to be Processors of personal data according to GDPR. Both parties commit on adhering to GDPR and other relevant legislation as for the handling of personal data.</p>

        <h3>7. Limitation of Liability</h3>
        <p class="section-title">7.1. Comstream is not responsible for any indirect damages of any kind and the liability is in all cases limited to the amount that the Customer has paid for the Service.</p>

        <h3>8. Applicable Laws</h3>
        <p class="section-title">8.1. This Contract shall be governed by the laws of Sweden and any dispute shall be settled by a general Swedish court of law.</p>
    </div>
</body>
</html>
`;
    },

    generateHtmlString() {
      return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Agreement for Consultancy Mediation Services</title>
    <style>
    @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
        .freelancing-container {
           font-family: "Lato", sans-serif;
           padding-left:40px;
           padding-right:40px;
        }
        .freelancing-container p {
          font-size: 14px
        }
        .freelancing-container  h2 {
          font-size:18px;
          font-weight:800;
        }
        .freelancing-container  h3 {
          font-weight:800;
          font-size:13px;
          margin-bottom:20px;
          margin-top:20px;
        }

        .freelancing-container .flex {
          display:flex;
          justify-content: space-between;
          align-items: center;
        }

        .freelancing-container .flex img {
        width:50%;
        height:auto;
        }
    </style>
</head>
<body>
      <div class="freelancing-container">
    <img style="max-width:200px; margin-bottom:60px; margin-left:-52px; margin-top:30px" src="https://jobshark.eu/img/comstream-logo.af65b641.png" alt="Comstream logo" />
        <h2 style="margin-bottom:30px;">Agreement for Freelance Mediation Services</h2>
        <p style="margin-bottom:25px;">
            This is an agreement between Comstream AB, a Swedish entity with registration number 556945-8911, hereinafter referred to as ”Comstream” and ${this.getManagerUserProfile.employer_name}, an entity based in ${this.getManagerUserProfile.employer_country.name} with registration number ${this.selectedFields.regNumber}, hereinafter referred to as “the Customer” regarding mediation of professional freelancers, hereinafter “the Service”.
        </p>
        <h3>1. General Conditions</h3>
        <p class="section-title">1.1. The Customer hereby appoints Comstream to find, qualify and present suitable individuals, hereinafter ”Candidates”, for a certain project, hereinafter ”the Project”. An accepted Candidate, hereinafter the “IT Professional”, is rented out by Comstream to the Customer on an hourly basis.</p>
        <p class="section-title">1.2. Comstream shall present hourly fee, CV and other relevant received information regarding a Candidate to the Customer. The Customer may not disclose information about the Candidate to third parties without Comstream’s prior approval.</p>
        <p class="section-title">1.3. On request by the Customer, Comstream shall provide possibility to interview the Candidate personally or by video meeting, phone or other similar way. In the occurrence of any travelling expenses related to such meetings, the Customer shall bear these costs.</p>
        <p class="section-title">1.4. The IT Professional is under the disposal, management and supervision of the Customer in order to conduct work that is related to the Customer’s business.</p>

        <h3>2. Responsibilities of the Parties</h3>
        <p class="section-title">2.1. Comstream shall use its best efforts to find suitable Candidates for the Customer for each Project.</p>
        <p class="section-title">2.2. It is the responsibility of the Customer to provide Comstream with an adequate description of the Project and other relevant information about the Project.</p>

        <h3>3. Fees and Payment Terms</h3>
        <p class="section-title">3.1. The Customer shall pay an hourly fee per IT Professional to Comstream. The fee will be invoiced monthly with twenty (20) days payment terms.</p>
        <p class="section-title">3.2. The level of the hourly rate is agreed upon as the Customer accepts a Candidate. Thereafter it may be revised every twelve (12) months by one (1) month’s written notice by Comstream.</p>
        <p class="section-title">3.3. Other paid actual costs, such as software license fees, allowances, travelling and lodging expenses, that may occur for the IT Professional based on instructions by the Customer are charged at cost price to the Customer.</p>
        <p class="section-title">3.4. If the customer, directly or indirectly, contracts or employs a Candidate without the written consent of Comstream, Comstream has the right to a compensation corresponding to 320 hours but never less than 12.000 EUR per Candidate.</p>
        <p class="section-title">3.5. In case of delay of payment of amounts due, the Customer shall be obliged to pay penalty interest amounting to 12% per year. All mentioned fees are exclusive of VAT.</p>
         <br/><br/>
        <h3>4. Termination</h3>
        <p class="section-title">4.1. Each Party may, at any time, terminate this Contract for all or for individual IT Professionals by thirty (30) days’ written notice.</p>
        <p class="section-title">4.2. Comstream’s right to compensation according to 3.4 is valid during the effective time of the agreement and one (1) year thereafter.</p>

        <h3>5. Secrecy and Intellectual Property Rights</h3>
        <p class="section-title">5.1. Any information received by one party shall be treated as strictly confidential by the other party and the receiving party shall not communicate the information in any form to any third party.</p>
        <p class="section-title">5.2. All intellectual property rights for what is produced by the IT Professional under this agreement shall be solely owned by the Customer, provided that this is not contradicting with applicable laws or regulations.</p>

        <h3>6. Processing of Personal Data</h3>
        <p class="section-title">6.1. Comstream and the Customer are jointly considered to be Processors of personal data according to GDPR. Both parties commit on adhering to GDPR and other relevant legislation as for the handling of personal data.</p>

        <h3>7. Limitation of Liability</h3>
        <p class="section-title">7.1. Comstream is not responsible for any indirect damages of any kind and the liability is in all cases limited to the amount that the Customer has paid for the Service.</p>

        <h3>8. Applicable Laws</h3>
        <p class="section-title">8.1. This Contract shall be governed by the laws of Sweden and any dispute shall be settled by a general Swedish court of law.</p>
          <div>
          <p style="margin-bottom:0px;" class="section-title">
              ${this.getManagerUserProfile.employer_city.name}, ${this.getManagerUserProfile.employer_country.name} on ${this.currentDate}
              </p>
              <p style="margin-bottom:0px;" class="section-title">
              ${this.getManagerUserProfile.employer_name}
              </p>
               <img style="width: 240px; height: 75px; object-fit: contain;" src="${this.signature}"/>
               <p style="margin-top:-6px;">
              ${this.getManagerUserProfile.first_name} ${this.getManagerUserProfile.last_name}
              </p>
              <div style="margin-top:-5px;">
              <span style="font-size:12px; margin-top:-12px;">This agreement was digitally signed on CET ${this.currentDateHours} by ${this.getManagerUserProfile.email}.</span>
              </div>
        </div>
    </div>
</body>
</html>
`;
    },

    getCETDate() {
      const date = new Date();
      const options = {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      const formatter = new Intl.DateTimeFormat('en-GB', options);
      const parts = formatter.formatToParts(date);
      const year = parts.find(part => part.type === 'year').value;
      const month = parts.find(part => part.type === 'month').value;
      const day = parts.find(part => part.type === 'day').value;

      this.currentDate = `${year}-${month}-${day}`;
    },

    getCETDateHours() {
      const date = new Date();
      const options = {
        timeZone: 'Europe/Paris',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      };
      const formatter = new Intl.DateTimeFormat('en-GB', options);
      const parts = formatter.formatToParts(date);
      const year = parts.find(part => part.type === 'year').value;
      const month = parts.find(part => part.type === 'month').value;
      const day = parts.find(part => part.type === 'day').value;
      const hour = parts.find(part => part.type === 'hour').value;
      const minute = parts.find(part => part.type === 'minute').value;
      const second = parts.find(part => part.type === 'second').value;

      this.currentDateHours = `${year}-${month}-${day}-${hour}:${minute}`;
    },
  },
  computed: {
    ...mapGetters([
      'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getAllCountries',
      'getLanguagesList',
    ]),
    ...mapGetters('managerStoreModule', [
      'getManagerProfile',
      'getManagerUserProfile',
      'getManagerJobsDropdown',
      'getManagerJobByID',
    ]),
  },
  watch: {
    'selectedFields.selectedCountry': function(newSelectedCountry) {
      localStorage.managerAddJobModalDataSelectedCountry = JSON.stringify(newSelectedCountry);
    },
    'selectedFields.selectedCity': function(newSelectedCity) {
      localStorage.managerAddJobModalDataSelectedCity = JSON.stringify(newSelectedCity);
    },
  },
  created() {
    if (localStorage.managerAddJobModalDataSelectedCountry) {
      const selectedCountry = JSON.parse(localStorage.managerAddJobModalDataSelectedCountry);
      this.selectedFields.selectedCountry = selectedCountry;
    }

    if (localStorage.managerAddJobModalDataSelectedCity) {
      const selectedCity = JSON.parse(localStorage.managerAddJobModalDataSelectedCity);
      this.selectedFields.selectedCity = selectedCity;
    }
  },
  mounted() {
    this.retrieveManagerJobsDropdown();

    if (this.$route.path === '/manager/user/jobs') {
      this.selectedFields.address = this.getManagerUserProfile.employer_address.address;
      this.selectedFields.postal = this.getManagerUserProfile.employer_address.postal_code;
      this.selectedFields.selectedCountry = this.userProfile.employer_country;
      this.selectedFields.selectedCity = this.userProfile.employer_city;
      this.selectedFields.benefits = this.getManagerUserProfile.employer_benefits;
      this.selectedFields.description = this.getManagerUserProfile.employer_description;
    } else {
      this.selectedFields.address = this.getManagerUserProfile.employer_address.address;
      this.selectedFields.postal = this.getManagerUserProfile.employer_address.postal_code;
      this.selectedFields.selectedCountry = this.userProfile.employer_country;
      this.selectedFields.selectedCity = this.userProfile.employer_city;
      this.selectedFields.benefits = this.getManagerUserProfile.employer_benefits;
      this.selectedFields.description = this.getManagerUserProfile.employer_description;
    }

    this.retrieveCitiesListByCountryId({ id: this.selectedFields.selectedCountry.id });
    // if (localStorage.addJobCountry) this.selectedFields.selectedCountry = localStorage.addJobCountry;

    this.retrieveCompetencesList();
    this.forceRerender();
    this.selectedFields.vat = this.getManagerUserProfile.employer_eu_vat_number;
    if (this.getManagerUserProfile.employer_invoice_email !== null) {
      this.selectedFields.invoiceEmail = this.getManagerUserProfile.employer_invoice_email;
    } else {
      this.selectedFields.invoiceEmail = this.getManagerUserProfile.employer_email;
    }
    this.selectedFields.regNumber = this.getManagerUserProfile.employer_registration_number;
  },
};
</script>

<style lang="scss" scoped>
.contract {
  max-height: 500px;
  padding-left: 8%;
  padding-right: 8%;
  padding-bottom: 30px;
  overflow-y: auto;
}

.custom-padding {
  padding-left: 11%;
  padding-right: 11%;
}

.textarea-hidden {
  height: 150px;
}

.form-group.required-fixed-right- {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.editor {
  box-shadow: 0px 2px 3px #0000000d;
  /* border: 1px solid #d7dae2; */
  border-radius: 4px;
  opacity: 1;
}

.social-buttons a {
  font-size: 0.875rem;
  font-weight: 400;
  box-shadow: 0px 1px 2px #00000029;
  border-radius: 4px;
}

.separator {
  position: relative;
  text-align: center;
  color: #b6b6b6;
  opacity: 0.8;

  span {
    display: inline-block;
    vertical-align: baseline;
    position: relative;
    padding: 0 20px;

    &:before,
    &:after {
      content: '';
      display: block;
      width: 5.5rem;
      position: absolute;
      top: 0.73em;
      border-top: 1px solid #b6b6b6;
    }

    &:before {
      right: 100%;
    }

    &:after {
      left: 100%;
    }
  }
}

.sign {
  justify-content: space-between;
  align-items: center;
  padding-left: 8%;
  padding-right: 8%;
}

.signature-pad {
  background: #fcf3b6;
  width: 100%;
  height: 170px;
}
/* MODAL */

/* Multi Step Form CSS */
.multisteps-form__progress {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.multisteps-form__progress-btn {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  position: relative;
  padding-top: 20px;
  color: rgba(108, 117, 125, 0.7);
  text-indent: -9999px;
  border: none;
  background-color: transparent;
  outline: none !important;
  cursor: pointer;
}
.form-group.required-fixed-right {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 9px;
    color: red;
    opacity: 0.6;
  }
}
.form-group.required-fixed-city {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

.required-fixed-country {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 7px;
    color: red;
    opacity: 0.6;
  }
}

.form-group {
  .form-control {
    padding-left: 8px;
  }
}

@media (min-width: 500px) {
  .multisteps-form__progress-btn {
    text-indent: 0;
  }
}

.multisteps-form__progress-btn:before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 13px;
  height: 13px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: all 0.15s linear 0s, -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s,
    -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  border: 2px solid currentColor;
  border-radius: 50%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 3;
}

.multisteps-form__progress-btn:after {
  position: absolute;
  top: 5px;
  left: calc(-50% - 13px / 2);
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: block;
  width: 100%;
  height: 2px;
  content: '';
  background-color: currentColor;
  z-index: 1;
}

.multisteps-form__progress-btn:first-child:after {
  display: none;
}

.multisteps-form__progress-btn.js-active {
  color: #0088cc;
}

.multisteps-form__progress-btn.js-active:before {
  -webkit-transform: translateX(-50%) scale(1.2);
  transform: translateX(-50%) scale(1.2);
  background-color: currentColor;
}

/* END MODAL */

/* Pagination */
.paginate {
  display: flex;
}

.paginate .prev {
  background: linear-gradient(90deg, #122549, #203762);
  text-align: right;
  justify-content: flex-end;
}

.paginate .next,
.paginate .prev {
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  width: 50%;
  padding: 0 2em;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
  cursor: pointer;
  transition: padding 0.5s cubic-bezier(0.19, 1, 0.22, 1);
}

button {
  outline: 0;
}

/* .next i {
  margin-left: 10px !important;
  transition: ease-in-out 0.4s;
} */

/* .next:hover i {
  margin-left: 20px !important;
  transition: all 0.4s;
} */

/* .prev i {
  margin-right: 10px !important;
  transition: ease-in-out 0.4s;
} */

/* .prev:hover i {
  margin-right: 20px !important;
  transition: ease-in-out 0.4s;
} */

button:disabled {
  cursor: not-allowed;
  opacity: 0.5;

  &:hover {
    color: blueviolet;
  }
}

@media screen and (min-width: 40em) {
  .paginate .next,
  .paginate .prev {
    height: 118px;
    font-size: 32px;
  }
}

select,
input[type='number'],
input[type='text'],
input[type='search'] {
  height: 3rem;
  padding-top: 8px;
  line-height: 1.3;
}

.search-typehead {
  min-height: 3rem !important;
}

.add-job-comments {
  padding-top: 1rem;
}

@media only screen and (max-width: 992px) {
  .contract {
    padding-left: 20px;
    padding-right: 20px;
    max-height: 450px;
  }

  .custom-padding {
    padding-left: 0;
    padding-right: 0;
  }

  .cs-button {
    white-space: wrap !important;
  }

  .modal-padding {
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
  }
}
</style>
